import Icon from "../Icon/Icon"

export const RequirmentCaracter: React.FC<{ label: string, isChecked: boolean }> = (props) => {
    const { label, isChecked } = props
    return (
        <li className={`flex flex-row items-center gap-2 ${isChecked ? "text-green-500" : "text-red-500"}`}>
            <Icon name={isChecked ? 'check' : "close"} />
            <small>{label}</small>
        </li>
    )
}